const initState = {
  deployId: null,
  buildInfo: null,
};

function deployCheck(state = initState, action) {
  switch (action.type) {
    case 'SET_DEPLOY_ID':
      return { ...state, deployId: action.deployId };
    case 'SET_BUILD_INFO':
      return { ...state, buildInfo: action.buildInfo };
    default:
      return state;
  }
}

export default deployCheck;
